"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ScaleContext_1 = require("../../context/ScaleContext");
const JGraphContext_1 = require("./JGraphContext");
const JsCoupling_1 = __importDefault(require("./JsCoupling"));
function JsCouplings(props) {
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    const { height } = (0, JGraphContext_1.useJGraph)();
    return ((0, jsx_runtime_1.jsx)("g", { className: "js-coupling", children: props.signals.map((signal) => {
            return ((0, jsx_runtime_1.jsxs)("g", { transform: `translate(${scaleX()(signal.delta)},0)`, children: [(0, jsx_runtime_1.jsx)("line", { x1: "0", y1: height, x2: "0", y2: "0", stroke: "black", strokeWidth: "1" }), signal.js?.map((j) => {
                        return (0, jsx_runtime_1.jsx)(JsCoupling_1.default, { value: j.coupling }, `${j.coupling}`);
                    })] }, signal.id));
        }) }));
}
exports.default = JsCouplings;
